/*
 * Eva Glamour — seleção por cor primeiro.
 *
 * O picker (product-variant-picker.liquid) renderiza a cor antes das demais
 * opções e já esconde, no servidor, os valores sem estoque na cor escolhida.
 * Este script cuida do momento da troca de cor: se o tamanho que estava
 * selecionado não existe na nova cor, ele passa a selecionar o primeiro
 * tamanho disponível antes do tema buscar a nova variante.
 */
(function () {
  if (window.evaVariantColorFirst) return;
  window.evaVariantColorFirst = true;

  function readAvailability(root) {
    var node = root.querySelector('[data-eva-variant-availability]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function optionGroups(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-option-position]'));
  }

  function currentValue(group) {
    var select = group.querySelector('select');
    if (select) return select.value;
    var checked = group.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function selectValue(group, value) {
    var select = group.querySelector('select');
    if (select) {
      var options = Array.prototype.slice.call(select.options);
      var option = options.filter(function (item) {
        return item.value === value;
      })[0];
      if (!option) return;
      options.forEach(function (item) {
        item.removeAttribute('selected');
      });
      select.value = value;
      option.setAttribute('selected', 'selected');
      return;
    }

    var input = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).filter(function (item) {
      return item.value === value;
    })[0];
    if (input) input.checked = true;
  }

  function firstAllowedValue(group, allowed) {
    var inputs = group.querySelectorAll('select option, input[type="radio"]');
    for (var index = 0; index < inputs.length; index++) {
      if (allowed.indexOf(inputs[index].value) !== -1) return inputs[index].value;
    }
    return null;
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var root = target.closest('variant-selects');
      if (!root) return;

      var group = target.closest('[data-option-position]');
      if (!group) return;

      var data = readAvailability(root);
      if (!data || !data.colorPosition || !data.combos || !data.combos.length) return;
      if (parseInt(group.dataset.optionPosition, 10) !== data.colorPosition) return;

      var colorIndex = data.colorPosition - 1;
      var color = target.tagName === 'SELECT' ? target.value : target.value;
      var combos = data.combos.filter(function (options) {
        return options[colorIndex] === color;
      });
      if (!combos.length) return;

      optionGroups(root).forEach(function (other) {
        var position = parseInt(other.dataset.optionPosition, 10);
        if (position === data.colorPosition) return;

        var allowed = combos.map(function (options) {
          return options[position - 1];
        });
        var selected = currentValue(other);
        if (selected !== null && allowed.indexOf(selected) !== -1) return;

        var replacement = firstAllowedValue(other, allowed);
        if (replacement) selectValue(other, replacement);
      });
    },
    true
  );
})();
